import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';


const MODULES = [
  { id: 'snags', label: 'Snags', icon: 'AlertTriangle', color: 'text-amber-600' },
  { id: 'incidents', label: 'Incidents', icon: 'ShieldAlert', color: 'text-red-600' },
  { id: 'documents', label: 'Documents', icon: 'FileText', color: 'text-slate-600' },
  { id: 'rams', label: 'H&S Docs', icon: 'HardHat', color: 'text-orange-600' },
  { id: 'diary', label: 'Site Diary', icon: 'BookOpen', color: 'text-purple-600' },
  { id: 'photos', label: 'Photos', icon: 'Camera', color: 'text-pink-600' },
  { id: 'certificates', label: 'Certificates', icon: 'Award', color: 'text-emerald-600' },
  { id: 'audits', label: 'Audits & Inspections', icon: 'ClipboardCheck', color: 'text-indigo-600' },
  { id: 'checklists', label: 'Checklists / Inspections', icon: 'CheckSquare', color: 'text-teal-600' },
];

const ReportConfigPanel = ({
  selectedModules,
  onModuleToggle,
  onSelectAllModules,
  reportType,
  onReportTypeChange,
  outputFormat,
  onOutputFormatChange,
}) => {
  const reportTypeOptions = [
    { value: 'compliance', label: 'Compliance Report' },
    { value: 'progress', label: 'Project Progress Summary' },
    { value: 'audit', label: 'Audit Findings' },
    { value: 'worker_performance', label: 'Worker Performance Analytics' },
    { value: 'custom', label: 'Custom Report' },
  ];

  const outputFormatOptions = [
    { value: 'pdf', label: 'PDF Document' },
    { value: 'csv', label: 'CSV Spreadsheet' },
  ];

  const allSelected = selectedModules?.length === MODULES?.length;

  return (
    <div className="bg-card border border-border rounded-xl p-5 space-y-6">
      <div className="flex items-center gap-2 mb-1">
        <div className="w-8 h-8 rounded-lg bg-accent/10 flex items-center justify-center">
          <Icon name="Settings2" size={16} color="var(--color-accent)" />
        </div>
        <h2 className="text-base font-semibold text-foreground font-heading">Report Configuration</h2>
      </div>

      {/* Report Type */}
      <div>
        <label className="block text-sm font-medium text-foreground mb-1.5">Report Template</label>
        <Select
          options={reportTypeOptions}
          value={reportType}
          onChange={(val) => onReportTypeChange(val)}
          placeholder="Select template..."
        />
      </div>

      {/* Output Format */}
      <div>
        <label className="block text-sm font-medium text-foreground mb-1.5">Output Format</label>
        <div className="flex gap-2">
          {outputFormatOptions?.map(opt => (
            <button
              key={opt?.value}
              onClick={() => onOutputFormatChange(opt?.value)}
              className={`flex-1 py-2 px-3 rounded-lg border text-sm font-medium transition-all ${
                outputFormat === opt?.value
                  ? 'border-accent bg-accent/10 text-accent' :'border-border text-muted-foreground hover:border-accent/50'
              }`}
            >
              {opt?.label}
            </button>
          ))}
        </div>
      </div>

      {/* Module Selection */}
      <div>
        <div className="flex items-center justify-between mb-2">
          <label className="block text-sm font-medium text-foreground">Data Modules</label>
          <button
            onClick={onSelectAllModules}
            className="text-xs text-accent hover:underline font-medium"
          >
            {allSelected ? 'Deselect All' : 'Select All'}
          </button>
        </div>
        <div className="grid grid-cols-2 gap-2">
          {MODULES?.map(mod => {
            const isSelected = selectedModules?.includes(mod?.id);
            return (
              <button
                key={mod?.id}
                onClick={() => onModuleToggle(mod?.id)}
                className={`flex items-center gap-2 p-2.5 rounded-lg border text-left transition-all ${
                  isSelected
                    ? 'border-accent bg-accent/5 text-foreground'
                    : 'border-border text-muted-foreground hover:border-border'
                }`}
              >
                <div className={`w-6 h-6 rounded flex items-center justify-center flex-shrink-0 ${
                  isSelected ? 'bg-accent/15' : 'bg-muted'
                }`}>
                  <Icon name={mod?.icon} size={13} className={isSelected ? 'text-accent' : mod?.color} />
                </div>
                <span className="text-xs font-medium leading-tight">{mod?.label}</span>
                {isSelected && (
                  <Icon name="Check" size={12} className="ml-auto text-accent flex-shrink-0" />
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ReportConfigPanel;
